__turbopack_context__.v({
  "absoluteLineBlock": "node-content-renderer-module-scss-module__gwDK9a__absoluteLineBlock",
  "arrow-pulse": "node-content-renderer-module-scss-module__gwDK9a__arrow-pulse",
  "blocksBackgroundColor": "node-content-renderer-module-scss-module__gwDK9a__blocksBackgroundColor",
  "blocksFontColor": "node-content-renderer-module-scss-module__gwDK9a__blocksFontColor",
  "button": "node-content-renderer-module-scss-module__gwDK9a__button",
  "buttonCollapsed": "node-content-renderer-module-scss-module__gwDK9a__buttonCollapsed",
  "buttonExpanded": "node-content-renderer-module-scss-module__gwDK9a__buttonExpanded",
  "highlightBottomLeftCorner": "node-content-renderer-module-scss-module__gwDK9a__highlightBottomLeftCorner",
  "highlightLineVertical": "node-content-renderer-module-scss-module__gwDK9a__highlightLineVertical",
  "highlightTopLeftCorner": "node-content-renderer-module-scss-module__gwDK9a__highlightTopLeftCorner",
  "lineBlock": "node-content-renderer-module-scss-module__gwDK9a__lineBlock",
  "lineChildren": "node-content-renderer-module-scss-module__gwDK9a__lineChildren",
  "loadingCircle": "node-content-renderer-module-scss-module__gwDK9a__loadingCircle",
  "loadingHandle": "node-content-renderer-module-scss-module__gwDK9a__loadingHandle",
  "moveHandle": "node-content-renderer-module-scss-module__gwDK9a__moveHandle",
  "row": "node-content-renderer-module-scss-module__gwDK9a__row",
  "rowCancelPad": "node-content-renderer-module-scss-module__gwDK9a__rowCancelPad",
  "rowContents": "node-content-renderer-module-scss-module__gwDK9a__rowContents",
  "rowLabel": "node-content-renderer-module-scss-module__gwDK9a__rowLabel",
  "rowLandingPad": "node-content-renderer-module-scss-module__gwDK9a__rowLandingPad",
  "rowSearchFocus": "node-content-renderer-module-scss-module__gwDK9a__rowSearchFocus",
  "rowSearchMatch": "node-content-renderer-module-scss-module__gwDK9a__rowSearchMatch",
  "rowToolbar": "node-content-renderer-module-scss-module__gwDK9a__rowToolbar",
  "rowWrapper": "node-content-renderer-module-scss-module__gwDK9a__rowWrapper",
  "rowWrapperDragDisabled": "node-content-renderer-module-scss-module__gwDK9a__rowWrapperDragDisabled",
  "secondaryNavBackgroundColor": "node-content-renderer-module-scss-module__gwDK9a__secondaryNavBackgroundColor",
  "themeBackgroundColor": "node-content-renderer-module-scss-module__gwDK9a__themeBackgroundColor",
  "themeFontColor": "node-content-renderer-module-scss-module__gwDK9a__themeFontColor",
  "toolbarButton": "node-content-renderer-module-scss-module__gwDK9a__toolbarButton",
});
